import { ENewbuildingActionTypes } from '../../actions/newbuilding';
import { INewBuilding } from '../../types/newbuilding';
import { TReduxActions } from '../../types/redux';

export function newbuildingReducer(state: INewBuilding = {} as INewBuilding, action: TReduxActions): INewBuilding {
  switch (action.type) {
    case ENewbuildingActionTypes.SetFavorite:
      return {
        ...state,
        isFavorite: action.payload,
      };
    case ENewbuildingActionTypes.SetFlatViewOrder: {
      return {
        ...state,
        flatViewOrder: {
          ...state.flatViewOrder,
          isEnabled: state.flatViewOrder?.isEnabled || false,
          orderStatus: action.payload,
        },
      };
    }
    default:
      return state;
  }
}
